import React, { useEffect, useState } from 'react'
import { getclustersbyId, getclustersglobalbyId, getclustersG, getclustersglobalG } from '../CTXRegister/request/request'
import { useAppSelector } from '../../../../redux/hooks'
import { useAuth } from '../../auth'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import styles from './cloudStatusTable.module.scss'; // Reutilizando el mismo estilo

type Props = {
  className: any
}

type Ctxr = {
  subid: any,
  name: any,
  description: any,
  localpref: any,
  statuspeer: boolean,
  lastupdatepeer: any,
  lastupdate: any,
  status: any
}

type data = {
  id: any,
  name: string,
  description: string,
  ctxr: Ctxr[],
  suscriptionId: any
}

const TablesWidget7: React.FC<Props> = ({ className }) => {
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const nameregion = useAppSelector(state => state.RegionSlice.name)
  const Cloud = useAppSelector(state => state.CloudSlice.Type)

  const { currentUser } = useAuth()

  const [Records, setrecords] = useState<data[]>([])

  // Estados para búsqueda, paginación, filtrado por columna y ordenación
  const [searchTerm, setSearchTerm] = useState("");
  const [searchColumn, setSearchColumn] = useState("All");

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);

  const [sortColumn, setSortColumn] = useState<string>("");
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc'
        ? <KeyboardArrowUpIcon className={styles['sort-icon']} />
        : <KeyboardArrowDownIcon className={styles['sort-icon']} />;
    } else {
      return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />;
    }
  }

  // Función para determinar el texto de estado del cluster
  const getStatusText = (d: data) => {
    const clusterStatus = d.ctxr.map(ctxrItem => ctxrItem.statuspeer)
    let statusText = 'Unknown'

    if (clusterStatus.every(status => status === true)) {
      statusText = 'Healthy'
    } else if (clusterStatus.every(status => status === false)) {
      statusText = 'Unhealthy'
    } else if (clusterStatus.some(status => status === false) && clusterStatus.some(status => status === true)) {
      statusText = 'Degraded'
    }

    return statusText
  }

  // Función para mapear el estado a una clase de badge
  const getBadgeClass = (statusText: string) => {
    return `badge ${statusText === 'Healthy' ? 'badge-success' :
      statusText === 'Degraded' ? 'badge-warning' :
        statusText === 'Unhealthy' ? 'badge-pink' :
          'badge-secondary'
      }`
  }

  function applySearch(data: data[]) {
    if (!searchTerm) return data;
    const lowerTerm = searchTerm.toLowerCase();

    return data.filter(d => {
      const statusText = getStatusText(d).toLowerCase();

      if (searchColumn === 'All') {
        return (
          d.name.toLowerCase().includes(lowerTerm) ||
          d.description.toLowerCase().includes(lowerTerm) ||
          statusText.includes(lowerTerm)
        );
      } else {
        let val = '';
        switch (searchColumn) {
          case 'name':
            val = d.name.toLowerCase();
            break;
          case 'description':
            val = d.description.toLowerCase();
            break;
          case 'status':
            val = statusText;
            break;
          default:
            val = '';
        }
        return val.includes(lowerTerm);
      }
    });
  }

  function applySort(data: data[]) {
    if (!sortColumn) return data
    const sorted = [...data].sort((a, b) => {
      const valA = getValueForSort(a, sortColumn);
      const valB = getValueForSort(b, sortColumn);

      if (valA < valB) return sortDirection === 'asc' ? -1 : 1
      if (valA > valB) return sortDirection === 'asc' ? 1 : -1
      return 0
    })
    return sorted
  }

  const getValueForSort = (item: data, column: string): string => {
    const statusText = getStatusText(item).toLowerCase();
    switch (column) {
      case 'name': return item.name.toLowerCase();
      case 'description': return item.description.toLowerCase();
      case 'status': return statusText;
      default: return '';
    }
  }

  const filteredData = applySort(applySearch(Records));

  const totalItems = filteredData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, endIndex);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    if (currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
      if (tenant === 0 && Id !== 0 && Cloud !== 'CloudGlobal') {
        getclustersbyId(Id, Cloud, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id !== 0 && Cloud !== 'CloudGlobal') {
        getclustersglobalbyId(Id, tenant, Cloud, nameregion).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant === 0 && Id === -1) {
        getclustersG(-1).then(response => {
          setrecords(response.data)
        })
      }
      else if (tenant !== 0 && Id === -1) {
        getclustersglobalG(-1, tenant).then(response => {
          setrecords(response.data)
        })
      }
    }
  }, [Id, Cloud, nameregion, currentUser, tenant])

  useEffect(() => {
    if (Id && Cloud !== '' || Cloud !== null) {
      if (Id !== 0 && Id !== -1 && tenant === 0 && Cloud === 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getclustersbyId(Id).then(response => {
          setrecords(response.data)
        })
      }
      else if (Id !== 0 && Id !== -1 && tenant !== 0 && Cloud === 'CloudGlobal' && currentUser?.ListPermiso?.includes('CTXR.GeneralStatus')) {
        getclustersglobalbyId(Id, tenant).then(response => {
          setrecords(response.data)
        })
      }
    }
  }, [Id, Cloud, nameregion, tenant, currentUser])

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1 f-titulo text-marino'>High Availability Status</span>
        </h3>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        <div className='tab-content'>

          {Records.length > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
                marginRight: '5px'
              }}
            >
              <div>
                <span className="text-marino f-parrafo fw-semibold">
                  Total Records: {totalItems}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                <div className="input-group custom-search-group" style={{ display: 'flex', height: '30px' }}>
                  <span
                    className="input-group-text"
                    style={{
                      justifyContent: 'center',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px'
                    }}
                  >
                    <i className="bi-search" style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}></i>
                  </span>
                  <select
                    className="form-select"
                    style={{
                      border: '1px solid var(--bs-gray-300)',
                      width: '120px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem'
                    }}
                    value={searchColumn}
                    onChange={(e) => { setSearchColumn(e.target.value); setCurrentPage(1); }}
                  >
                    <option value="All">All</option>
                    <option value="name">Name</option>
                    <option value="description">Description</option>
                    <option value="status">Status</option>
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      width: '150px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem'
                    }}
                    placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          )}

          {/* begin::Table container */}
          <div className='table-responsive'>
            {Records.length === 0 ? (
              <div className="no-data-message">No Data Available</div>
            ) : (
              <>
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead>
                    <tr className="text-azul text-left">
                      <th
                        className="table-cell"
                        onClick={() => handleSort('name')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Cluster Name</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('name')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        onClick={() => handleSort('description')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Description</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('description')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        onClick={() => handleSort('status')}
                        style={{ cursor: 'pointer' }}
                      >
                        <div className={styles['header-content']}>
                          <span>Status</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('status')}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData.map((d, m) => {
                      const statusText = getStatusText(d);
                      const badgeClass = getBadgeClass(statusText);

                      return (
                        <tr key={m} className="table-row">
                          <td className="table-cell">{d.name}</td>
                          <td className="table-cell">{d.description}</td>
                          <td className="table-cell">
                            <span className={badgeClass}>{statusText}</span>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>

                {/* Paginación */}
                {filteredData.length > 0 && (
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                    <div>
                      {currentPage > 1 && (
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Previous
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span>Page {currentPage} of {totalPages}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      {currentPage < totalPages && (
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Next
                        </button>
                      )}

                      <div className={`select-container ${styles.selectContainer}`}>
                        <select
                          className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                          aria-label="Select items per page"
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value))
                            setCurrentPage(1)
                          }}
                        >
                          <option value={5}>5 rows</option>
                          <option value={10}>10 rows</option>
                          <option value={20}>20 rows</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {/* end::Table */}
        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

export { TablesWidget7 }
